export default __webpack_public_path__ + "static/media/b26871465f3d606fb9b372246d2006ec.svg";